<ng-template #contextMenu let-row>
	<section class="user-menu">
		@for (item of filteredMenuItems; track item) {
			<div (click)="onSelection(item.value, row)">{{ item.text }}</div>
		}
	</section>
</ng-template>
